var React = require('react');
const NotificationIconContainer = require('./NotificationIconContainer');
const { connect } = require('react-redux');
const { withTranslation, useTranslation } = require('react-i18next');
const NotificationsCenterContainer = require('./NotifiactionsCenterContainer');
const $ = require('jquery');
const { useEffect, useState } = require('react');
var {
  syncNotificationsFeed,
} = require('../../../managers/notificationsFeedThunks');

const NotificationsCenterHeaderContainer = (props) => {
  const { isLoggedIn, dispatch } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Bumped on every open so the panel re-applies the currently watched
  // distribution / farming unit as its filter default. The widget stays mounted
  // across opens, so without this the filters would keep the first open's
  // selection even after the user switches entities in the header.
  const [openCount, setOpenCount] = useState(0);
  const { t } = useTranslation();

  const hideModal = () => {
    setIsModalOpen(false);
    $('#NotificationsCenterModal').addClass('hide');
    setTimeout(() => {
      $('#NotificationsCenterModal').modal('hide');
    }, 700); // Adjust this delay to match the transition duration
  };

  const displayModal = () => {
    setIsModalOpen(true);
    setOpenCount((previousOpenCount) => previousOpenCount + 1);
    $('#NotificationsCenterModal').modal('show');
    if (isLoggedIn) {
      dispatch(syncNotificationsFeed());
    }
  };

  useEffect(() => {
    const modalEl = document.getElementById('NotificationsCenterModal');

    const handleHidden = function () {
      setIsModalOpen(false);
      $(this).removeClass('hide');
    };

    const handleDocumentMouseDown = (event) => {
      if (!modalEl) return;
      const isOpen = $(modalEl).hasClass('show');
      if (!isOpen) return;
      const dialogEl = modalEl.querySelector('.modal-dialog');
      if (dialogEl && !dialogEl.contains(event.target)) {
        hideModal();
      }
    };

    $(modalEl).on('hidden.bs.modal', handleHidden);
    document.addEventListener('mousedown', handleDocumentMouseDown);
    return () => {
      $(modalEl).off('hidden.bs.modal', handleHidden);
      document.removeEventListener('mousedown', handleDocumentMouseDown);
    };
  }, []);

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', marginLeft: 'auto' }}
    >
      <div
        className='modal modal-tall modal-slide'
        tabIndex='-1'
        role='dialog'
        id='NotificationsCenterModal'
        data-backdrop='false'
        aria-labelledby='NotificationsCenterModalLabel'
        aria-hidden='true'
      >
        <div
          className='modal-dialog modal-dialog-slide'
          role='document'
          style={{
            position: 'fixed',
            margin: 'auto',
            width: '360px',
            height: '96%',
            marginTop: '48px',
            right: '-1px',
          }}
        >
          <div
            className='modal-content'
            style={{
              height: '100%',
              borderRadius: '0px',
              borderTop: '1px solid #DCE0E8',
              borderLeft: '1px solid #DCE0E8',
              boxShadow:
                '0px 4px 8px 0px rgba(145, 157, 180, 0.18), 0px 1px 4px 0px rgba(146, 158, 181, 0.10)',
            }}
          >
            <div
              className='modal-header'
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '17px 24px 23px 16px',
                borderBottom: '0px',
              }}
            >
              <h5 className='modal-title font-weight-bold text-grey45 text-size-24'>
                {t('notifications')}
              </h5>
              <button
                type='button'
                className='close'
                onClick={hideModal}
                style={{ opacity: 1, outline: 'none' }}
              >
                <img src={require('images/icons/close_button.svg')} />
              </button>
            </div>
            <div className='modal-body p-0' style={{ overflowY: 'auto' }}>
              <NotificationsCenterContainer
                isModalOpen={isModalOpen}
                openCount={openCount}
                onCloseClicked={hideModal}
                openFromMainDashboard={props.openFromMainDashboard}
              />
            </div>
          </div>
        </div>
      </div>
      <NotificationIconContainer onIconClicked={displayModal} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: !!state.authentication_data.tokens?.id_token,
});

module.exports = connect(mapStateToProps)(
  withTranslation()(NotificationsCenterHeaderContainer),
);
